exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".table th,td{font-size:12px}", "", {"version":3,"sources":["D:/app/gocode/src/gitlab.com/satit13/VillageService/ui/src/views/reportwater.vue"],"names":[],"mappings":"AACA,aAEE,cAAgB,CACjB","file":"reportwater.vue","sourcesContent":["\n.table th,\r\ntd {\r\n  font-size: 12px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57223c21","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/reportwater.vue
// module id = 412
// module chunks = 16